module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//blue_2.png?v=42f61105";